import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const BayesiaPage = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/integrations/bayesia/")({
  beforeLoad: () => {
    throw redirect({ to: "/integrations/bayesia/inferences" });
  },
  component: BayesiaPage,
});
